/* global Dida */

export function addStat(statStr, userCid, minitype) {
  if (typeof Dida !== 'undefined') {
    try {
      userCid && Dida.config({ app_user_cid: userCid })
      if (statStr === 'config') return

      // 触发埋点
      Dida.send('view', {
        code: statStr,
        data: {
          app_name: '领券模板',
          tagName: 'body',
          name: statStr,
          minitype
        }
      })
    } catch (e) {
      console.error('addStat', e)
    }
  }
}

export function addStat2(statStr, userCid, goodCid, envir) {
  if (typeof Dida !== 'undefined') {
    try {
      userCid && Dida.config({ app_user_cid: userCid })
      if (statStr === 'config') return

      // 触发埋点
      Dida.send('view', {
        code: statStr,
        data: {
          app_name: '领券模板',
          tagName: 'body',
          name: statStr,
          goodCid,
          envir
        }
      })
    } catch (e) {
      console.error('addStat', e)
    }
  }
}
